import { useSearchParams } from "react-router-dom";
import { CheckCircle2, Download } from "lucide-react";
import QuoteForm from "@/components/QuoteForm";
import { SITE, WAREHOUSE_IMAGE } from "@/lib/site";

const BENEFITS = [
  "24-hour response from a dedicated sourcing manager",
  "Best-price sourcing from 80+ global brand partners",
  "2–3 vetted alternatives with pricing & lead time",
  "Full material and batch traceability documentation",
];

export default function Quote() {
  const [params] = useSearchParams();
  const defaultCategory = params.get("category") || "";

  return (
    <main data-testid="quote-page" className="mx-auto max-w-7xl px-4 md:px-6 lg:px-8">
      <section className="pt-16 md:pt-24 pb-16 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <div className="text-xs uppercase tracking-widest text-slate-500">Request a Quote</div>
          <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tighter leading-[1.05] mt-2">
            Get pricing in <span className="gfe-gradient-text">24 hours.</span>
          </h1>
          <p className="text-slate-600 mt-4">Tell us what you need. Our team will come back with pricing, lead time and alternatives — no obligation.</p>

          <ul className="mt-8 space-y-3">
            {BENEFITS.map((b) => (
              <li key={b} className="flex items-start gap-3 text-sm text-slate-800">
                <CheckCircle2 className="w-5 h-5 text-orange-500 mt-0.5 shrink-0" /> {b}
              </li>
            ))}
          </ul>

          <div className="mt-10 rounded-2xl overflow-hidden border border-slate-200">
            <img src={WAREHOUSE_IMAGE} alt="warehouse" className="w-full h-56 object-cover" />
          </div>

          <a href={SITE.catalogue} target="_blank" rel="noreferrer" data-testid="quote-catalogue-download"
            className="btn-ghost inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold mt-6">
            <Download className="w-4 h-4" /> Prefer PDF? Download the catalogue
          </a>
        </div>

        <div className="lg:col-span-7">
          <div className="rounded-3xl border border-slate-200 p-6 md:p-10 bg-white shadow-sm">
            <QuoteForm defaultCategory={defaultCategory} />
          </div>
        </div>
      </section>
    </main>
  );
}
